import { Service } from '@roc/feature-app-core';

const url = {
  GET_SIGNING_INFO: '/api/v1/loan/extensionSigning/info',
  SIGN_EXTENSION_AGREEMENT: '/api/v1/loan/extensionSigning/sign',
};

export class BorrowerExtensionSigningService extends Service {
  getExtensionSigningInfo(loanExtensionId: number) {
    return this.get(`${url.GET_SIGNING_INFO}?loanExtensionId=${loanExtensionId}`);
  }

  signExtensionAgreement(data) {
    return this.post(url.SIGN_EXTENSION_AGREEMENT, data);
  }
}
